import { isArray, LayerTypeGroupId, LmNode } from "../omnia"

export function applyFilters(nodes: LmNode[], types: LayerTypeGroupId[]) {

    if (!isArray(nodes)) {
        return
    }

    const hasTypeFilter = types && (types.length > 0)

    nodes.forEach(n => {

        const children = n.getChildren(true)

        applyFilters(children, types)

        let visible = n.layer || (n.class == "holding") || (!hasTypeFilter) || (children && children.some(c => !c.filtered))

        visible = visible && (
            (!n.layerTypeGroup) || (!hasTypeFilter) || (types.some(t => t == n.layerTypeGroup))
        )

        visible = visible && (
            (!n.field)
            || (n.field.visible)
            || (n.field.fieldVm && n.field.fieldVm.visible)
        )

        n.filtered = !visible

        if (n.layer && (!visible)) {
            n.layer.visible = false
        }

    })

}
